import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../../util/constants";
import * as types from "../../types";
import {handleUnauthorizedAccess} from "../../../util/utility";

export function purchaseChatContent(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/viewer/chat_post/purchase?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.PURCHASE_CHAT_CONTENT_REQUEST, types.PURCHASE_CHAT_CONTENT_RECEIVE, {
                type: types.PURCHASE_CHAT_CONTENT_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetPurchaseChatContent = () => ({
    type: types.RESET_PURCHASE_CHAT_CONTENT,
    payload: null
});